import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TabNavLink from './TabNavlink';
import FingoWatermarkLogo from '../../assets/icons/logos/fingo_watermark';
import LazyLoadImage from '../images/LazyLoadImage';

// Owns the tab bar container: visibility when there is a single tab and, for scrollable
// bars, the horizontal overflow behavior. Layouts only choose scrollableTabs.
const Tabs = ({ tabs, useFingoWatermark, scrollableTabs, tabSearch }) => {
  const hasManyTabs = tabs.length > 1;
  return (
    <Grid
      container
      sx={{
        opacity: hasManyTabs ? '100%' : '0%',
        display: { xs: hasManyTabs ? 'flex' : 'none', md: 'auto' },
        flexWrap: scrollableTabs ? 'nowrap' : { xs: 'nowrap' },
        ...(scrollableTabs && { overflowX: 'auto', scrollbarWidth: 'thin' }),
      }}
    >
      {tabs.map(({ id, label, path, quantity, preserveSearch: tabPreserveSearch }, index) => (
        <TabNavLink
          id={id}
          key={id}
          label={label}
          path={path}
          quantity={quantity}
          index={index}
          optionsCount={tabs.length + (useFingoWatermark ? 1 : 0)}
          scrollable={scrollableTabs}
          preserveSearch={tabPreserveSearch}
          tabSearch={tabSearch}
        />
      ))}
      {useFingoWatermark && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingX: 2,
            paddingY: 1,
            marginLeft: 'auto',
          }}
        >
          <LazyLoadImage
            src={FingoWatermarkLogo}
            alt="Fingo Logo"
            width={119}
            format="webp"
          />
        </Box>
      )}
    </Grid>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.shape()]).isRequired,
    path: PropTypes.string,
    component: PropTypes.element,
    quantity: PropTypes.number,
    preserveSearch: PropTypes.bool,
  })).isRequired,
  useFingoWatermark: PropTypes.bool,
  scrollableTabs: PropTypes.bool,
  tabSearch: PropTypes.shape({
    preserveSearchPaths: PropTypes.arrayOf(PropTypes.string),
    defaultTabPath: PropTypes.string,
    activeTabPath: PropTypes.string,
    currentSearch: PropTypes.string,
  }),
};
Tabs.defaultProps = {
  useFingoWatermark: false,
  scrollableTabs: false,
  tabSearch: {},
};

export default Tabs;
